import { DEPARTEMENTS_P1, DEPARTEMENTS_P2 } from "@/data/departements";

/**
 * Grille de badges départements — motif signature du site.
 * variant: "compact" (accueil) | "full" (page zones)
 */
export default function DepartementsGrid({ variant = "compact", showSecondary = true }) {
  return (
    <div className="w-full" data-testid="departements-grid">
      {/* Priorité 1 */}
      <div className="grid grid-cols-3 sm:grid-cols-5 gap-2 sm:gap-3">
        {DEPARTEMENTS_P1.map((d) => (
          <div
            key={d.code}
            className="dept-badge primary"
            aria-label={`Département ${d.code} — ${d.nom}`}
            data-testid={`dept-p1-${d.code}`}
          >
            <span className="code">{d.code}</span>
            {variant === "full" && <span className="name">{d.nom}</span>}
          </div>
        ))}
      </div>

      {/* Priorité 2 */}
      {showSecondary && (
        <div className="mt-3 sm:mt-4">
          <div className="flex items-center gap-3 mb-2 sm:mb-3">
            <div className="h-px flex-1" style={{ background: "var(--border-light)" }}></div>
            <div className="font-mono text-[11px] uppercase tracking-wider" style={{ color: "var(--ink-muted)" }}>
              Couverture secondaire
            </div>
            <div className="h-px flex-1" style={{ background: "var(--border-light)" }}></div>
          </div>
          <div className="grid grid-cols-3 gap-2 sm:gap-3">
            {DEPARTEMENTS_P2.map((d) => (
              <div
                key={d.code}
                className="dept-badge secondary"
                aria-label={`Département ${d.code} — ${d.nom} (couverture secondaire)`}
                data-testid={`dept-p2-${d.code}`}
              >
                <span className="code">{d.code}</span>
                {variant === "full" && <span className="name">{d.nom}</span>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
